const Video = () => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2760_13841)'>
        <path
          d='M10.2267 16.875L16.3631 12.2727L10.2267 7.67045V16.875ZM12.2722 2.04545C6.62674 2.04545 2.04492 6.62727 2.04492 12.2727C2.04492 17.9182 6.62674 22.5 12.2722 22.5C17.9176 22.5 22.4995 17.9182 22.4995 12.2727C22.4995 6.62727 17.9176 2.04545 12.2722 2.04545ZM12.2722 20.4545C7.76197 20.4545 4.09038 16.783 4.09038 12.2727C4.09038 7.7625 7.76197 4.09091 12.2722 4.09091C16.7824 4.09091 20.454 7.7625 20.454 12.2727C20.454 16.783 16.7824 20.4545 12.2722 20.4545Z'
          fill='#161410'
        />
      </g>
      <defs>
        <clipPath id='clip0_2760_13841'>
          <rect width='24.5455' height='24.5455' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Video;
